import { formatDistanceToNow } from 'date-fns';
import type { PapSyncData } from '@/features/organization/hooks/usePapSync';

export function PapSyncStatus({
  papSync,
  isSyncing,
  className,
}: {
  papSync?: PapSyncData;
  isSyncing?: boolean;
  className?: string;
}) {
  if (isSyncing && papSync?.status === 'running' && papSync.progress) {
    const { pagesProcessed, productsProcessed, skusUpserted } = papSync.progress;
    return (
      <span className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className ?? ''}`}>
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
        Syncing... {productsProcessed} products, {skusUpserted} SKUs ({pagesProcessed} pages)
      </span>
    );
  }

  if (isSyncing) {
    return (
      <span className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className ?? ''}`}>
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
        Starting sync...
      </span>
    );
  }

  if (!papSync?.lastCompletedAt) return null;

  const lastSynced = new Date(papSync.lastCompletedAt);
  const ageMs = Date.now() - lastSynced.getTime();
  const isRecent = ageMs < 24 * 60 * 60 * 1000;

  return (
    <span className={`flex items-center gap-1.5 text-xs text-muted-foreground ${className ?? ''}`}>
      <span
        className={`inline-block h-1.5 w-1.5 rounded-full ${isRecent ? 'bg-green-500' : 'bg-amber-500'}`}
      />
      Last synced {formatDistanceToNow(lastSynced, { addSuffix: true })}
      {papSync.progress
        ? ` (${papSync.progress.productsProcessed} products, ${papSync.progress.skusUpserted} SKUs)`
        : ''}
    </span>
  );
}
